import { InjectionToken } from '@angular/core';
import { KEYCLOAK_ROLES } from '../../shared/constants/auth.constants';

// Ação do botão da novidade na modal.
export type WhatsNewAction =
  | { type: 'open'; label: string; route: string } // ex.: "Abrir pedidos"
  | { type: 'activate'; route: string } // rótulo fixo "Ativar agora"
  | { type: 'support'; subject: string } // ex.: "ativar a emissão automática de notas"
  | { type: 'none' };

export interface WhatsNewItem {
  id: string;
  /** AAAA-MM-DD (dia local do lançamento). */
  date: string;
  title: string;
  text: string;
  videoUrl: string;
  posterUrl: string;
  action: WhatsNewAction;
  /** Perfil exigido (KEYCLOAK_ROLES). Ausente = qualquer usuário. */
  role?: string;
}

// Espelho de GET users/me/whats-new (datas em UTC ISO).
export interface WhatsNewState {
  firstAccessAt: string;
  seen: { id: string; seenAt: string }[];
}

// Tempos da modal em segundos: o cartão entra em `entrance`; o vídeo começa `startDelay` depois de
// pronto (na abertura, depois também do fim da entrada), para em `sceneEnd` (depois disso o vídeo
// escurece pro loop) e a próxima entra `advanceAfter` depois.
export const WHATS_NEW_RULES = {
  lockSeconds: 5,
  entrance: 0.3,
  startDelay: 0.4,
  sceneEnd: 10,
  advanceAfter: 1.2,
  /** Espera máxima pelo 1º vídeo (baixando desde a abertura do app) antes de abrir a modal. */
  preloadWait: 4,
  maxPerDay: 2,
  validityDays: 30,
} as const;

// Novidades em ordem de lançamento. Os arquivos ficam no bucket -dev por enquanto (o de produção ainda não existe).
export const WHATS_NEW: readonly WhatsNewItem[] = [
  {
    id: '2026-10-emissao-automatica',
    date: '2026-10-30',
    title: 'Emissão automática de notas',
    text: 'O ERP emite a nota assim que confirma o pedido com estoque.',
    videoUrl:
      'https://storage.googleapis.com/market-connector-advertisements-dev/novidades/2026-10-emissao-automatica.mp4',
    posterUrl:
      'https://storage.googleapis.com/market-connector-advertisements-dev/novidades/2026-10-emissao-automatica-poster.jpg',
    action: { type: 'support', subject: 'ativar a emissão automática de notas' },
  },
  {
    id: '2026-10-conferencia-celular',
    date: '2026-10-30',
    title: 'Conferência pelo celular',
    text: 'A câmera do celular lê a nota e cada item. Confira longe do leitor USB.',
    videoUrl:
      'https://storage.googleapis.com/market-connector-advertisements-dev/novidades/2026-10-conferencia-celular.mp4',
    posterUrl:
      'https://storage.googleapis.com/market-connector-advertisements-dev/novidades/2026-10-conferencia-celular-poster.jpg',
    action: { type: 'open', label: 'Abrir conferência', route: '/conferencia/camera' },
    role: KEYCLOAK_ROLES.SALE_CONFERENCE,
  },
];

// Injetável pra os testes trocarem a lista sem mexer na constante.
export const WHATS_NEW_ITEMS = new InjectionToken<readonly WhatsNewItem[]>('WHATS_NEW_ITEMS', {
  factory: () => WHATS_NEW,
});

// Número do suporte: só dígitos com DDI. Vazio = ação de suporte oculta.
export const SUPPORT_WHATSAPP: string = '5541997280776';
